import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { isExcluded } from '@core/interceptors/interceptors.config';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs/operators';
import { take } from 'rxjs';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { authSelectors } from '@store/selectors/auth.selectors';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method === 'options' || isExcluded(req.url)) {
    return next(req);
  }
  const oidcSecurity = inject(OidcSecurityService);
  const store = inject(Store<StoreState>);
  return store.select(authSelectors.idp).pipe(
    take(1),
    switchMap((idp) => (idp == null ? oidcSecurity.getIdToken() : oidcSecurity.getIdToken(idp))),
    switchMap((token) =>
      next(
        req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      )
    )
  );
};
